import classNames from 'classnames'
import Text from '../../components/Text'

const SignupPageHeader = ({
  handlePreviousStep = () => {},
  progress = 0,
  step = 0,
  totalSteps = 0,
  themeColor = '#299D6B',
  rightImage = null,
  containerClassName = '',
  cgmType,
}) => {
  if (totalSteps < 2) return null
  return (
    <div className="px-4 border-b border-[#E4E7EC] relative">
      <div
        className={classNames('w-full max-w-xl pt-5 pb-2', containerClassName)}
      >
        {/* back button */}
        <div
          className="flex items-center gap-2 max-w-max"
          onClick={handlePreviousStep}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
          >
            <path
              d="M9.40767 3.44425C9.39272 3.42924 8.93464 3.31442 8.38979 3.18919C7.84488 3.06396 7.39315 2.98064 7.38589 3.0039C7.37869 3.02722 7.32231 3.40542 7.26066 3.84438C7.13682 4.72587 6.83696 5.75507 6.51656 6.39873C5.51784 8.40475 3.72597 9.73302 1.55267 10.0783L0.999249 10.1662L0.999249 11.0523L0.999249 11.9386L1.50085 12.0227C4.78716 12.5741 6.92967 15.0313 7.33047 18.7085C7.35663 18.9486 7.3879 19.145 7.39994 19.145C7.51077 19.145 9.34727 18.7024 9.382 18.6674C9.40712 18.642 9.38843 18.4169 9.34042 18.1672C8.80899 15.4024 7.28737 13.1525 5.31278 12.2118L4.83912 11.9861L14.5792 11.9685L20.7383 11.9573L20.7383 10.1638L14.5634 10.1526L4.84625 10.1348L5.44423 9.83185C6.99554 9.04591 8.22374 7.5042 8.94702 5.43484C9.15313 4.8453 9.46412 3.50124 9.40767 3.44425Z"
              fill="#344054"
            />
          </svg>
          <Text tag="p" variant="label" size="large">
            Back
          </Text>

          {rightImage && (
            <div className="right-4 absolute flex items-center justify-center">
              <img
                src={rightImage}
                alt="right-image"
                className="w-18 h-8 right-4 top-0"
              />
            </div>
          )}
        </div>
        {/* steps label */}
        <div className="text-gray-600 py-2 flex items-center gap-1">
          <Text
            tag="p"
            variant="body"
            size="large"
            style={{ color: themeColor }}
          >
            Step {step + 1}
          </Text>
          <Text tag="p" variant="body" size="large">
            of {totalSteps}
          </Text>
        </div>
        {/* Progress Bar */}
        <div className="w-full bg-gray-200 rounded-full h-1">
          <div
            className="h-1 rounded-full transition-all duration-500"
            style={{
              width: `${progress}%`,
              backgroundColor: themeColor,
            }}
          />
        </div>
      </div>
    </div>
  )
}

export default SignupPageHeader
